import { createApp } from 'vue'
import ElementPlus, { ElMessage } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import App from './App.vue'
import router from './router'
import createPermissionGuard from './router/permissionGuard'
import { setupStore } from './store'
import SvgIcon from '@/components/SvgIcon.vue'
import '@/utils/fetch';
import '@/assets/fonts/Amiko/index.css'
import '@/assets/fonts/PingFangSC/index.css'
import '@/assets/fonts/FZYaoTi/index.css'
import './styles/index.scss'

const app = createApp(App)
app.component('svg-icon', SvgIcon)
app.use(ElementPlus, { locale: zhCn })
setupStore(app)
app.use(router)

app.config.globalProperties.$message = ElMessage
app.mount('#app') 
createPermissionGuard(router)